import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const BackgroundShapes = ({
  variant = "default",
  opacity = 0.05
}) => {
  const getBackgroundPattern = () => {
    switch (variant) {
      case "dots":
        return `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2343a047' fill-opacity='${opacity}' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E")`;
      case "cross":
        return `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2343a047' fill-opacity='${opacity}'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`;
      default:
        return `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2343a047' fill-opacity='${opacity}' fill-rule='evenodd'%3E%3Cpath d='M20 20c0 4.9-8.954 9-20 9s-20-4.1-20-9 8.954-9 20-9 20 4.1 20 9z'/%3E%3C/g%3E%3C/svg%3E")`;
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        background: `
          radial-gradient(circle at 20% 80%, rgba(67, 160, 71, 0.15) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(255, 196, 0, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 40% 40%, rgba(0, 184, 148, 0.1) 0%, transparent 50%),
          linear-gradient(135deg, #f8faf8 0%, #e6f4ea 100%)
        `,
        backgroundSize: '200% 200%',
        animation: 'gradientShift 20s ease infinite',
        '@keyframes gradientShift': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: getBackgroundPattern(),
          animation: 'float 25s ease-in-out infinite',
        },
        '@keyframes float': {
          '0%, 100%': { transform: 'translateY(0px)' },
          '50%': { transform: 'translateY(-15px)' },
        },
      }}
    />
  );
};

export default BackgroundShapes;
